import React, { useState } from 'react';
import './Select.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { IntentType } from '../Intent';

export interface SelectProps {
  id: string;
  children: React.ReactNode;
  value?: string;
  className?: string;
  size?: 'small' | 'default' | 'large';
  disabled?: boolean;
  intent?: IntentType;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  onFocus?: React.FocusEventHandler<HTMLSelectElement>;
  onBlur?: React.FocusEventHandler<HTMLSelectElement>;
  /**
   * The other associated HTML props of the select element
   */
  htmlAttributes?: React.InputHTMLAttributes<HTMLSelectElement>
}


const Select: React.FC<SelectProps> = (props) => {
  const { id, children, value = '', className = '', intent = 'none', size = 'default', disabled = false, onChange, onFocus, onBlur, htmlAttributes } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleFocus = (event: React.FocusEvent<HTMLSelectElement>): void => {
    setIsOpen(true);
    onFocus?.(event);
  };
  const handleBlur = (event: React.FocusEvent<HTMLSelectElement>): void => {
    setIsOpen(false);
    onBlur?.(event);
  };

  const selectProps: React.InputHTMLAttributes<HTMLSelectElement> = {
    ...htmlAttributes,
    id,
    name: id,
    onChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled,
  };
  if (value !== undefined) {
    selectProps.value = value;
  }

  return (
    <div className={`container ${className ?? ''} ${'intent-' + intent} ${'size-' + size}`}>
      <select {...selectProps}>{children}</select>
      {/* <Icon className='arrow' icon={isOpen ? 'chevronUp' : 'chevronDown'} /> */}
      <FontAwesomeIcon icon={isOpen ? faAngleUp : faAngleDown } className="arrow" />
    </div>
  );
};

export default Select;
